import { render, staticRenderFns } from "./cv-header.vue?vue&type=template&id=21be1d5c&"
import script from "./cv-header.vue?vue&type=script&lang=js&"
export * from "./cv-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports